<div *ngIf="this.matchLink && !isHidden()" class="reporter-banner {{ colorScheme.main }} scale-on-hover"
   (click)="onClick()">
  <h4>Klicke hier, um das Spiel für <strong>{{team.name}}</strong> zu tickern!</h4>
  <mat-icon>add</mat-icon>
</div>
